interface Props {
  isOn: boolean;
  setIsOn: any;
}

const Toggle: React.FC<Props> = ({ isOn, setIsOn }) => {
  return (
    <>
      <div
        className={`${
          isOn ? 'bg-[#00AEB3]' : 'bg-[#aaaaaa]'
        } relative h-[14px] w-[30px] rounded-full`}
        onClick={() => setIsOn(!isOn)}
      >
        <div
          className={`${
            isOn ? 'left-[16px]' : 'left-[2px]'
          } absolute  top-[1px] h-[12px] w-[12px] rounded-full bg-white duration-300`}
        ></div>
      </div>
    </>
  );
};

export default Toggle;
